import ProdigyInput from './ProdigyInput';

export default ProdigyInput;
